import * as React from 'react';

const SvgInmail = (props) => (
  <svg
    width={56}
    height={56}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill="#E0EAFF" />
    <path
      d="M33.2373 24C34.8286 24 36.3547 24.6321 37.4799 25.7574C38.6052 26.8826 39.2373 28.4087 39.2373 30V37H35.2373V30C35.2373 29.4696 35.0266 28.9609 34.6515 28.5858C34.2764 28.2107 33.7677 28 33.2373 28C32.7069 28 32.1982 28.2107 31.8231 28.5858C31.448 28.9609 31.2373 29.4696 31.2373 30V37H27.2373V30C27.2373 28.4087 27.8694 26.8826 28.9947 25.7574C30.1199 24.6321 31.646 24 33.2373 24V24Z"
      stroke="#444CE7"
      strokeWidth={1.45946}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.2373 25H19.2373V37H23.2373V25Z"
      stroke="#444CE7"
      strokeWidth={1.45946}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.2373 22C22.3419 22 23.2373 21.1046 23.2373 20C23.2373 18.8954 22.3419 18 21.2373 18C20.1327 18 19.2373 18.8954 19.2373 20C19.2373 21.1046 20.1327 22 21.2373 22Z"
      stroke="#444CE7"
      strokeWidth={1.45946}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke="#F6F7FF"
      strokeWidth={8}
    />
  </svg>
);

export default SvgInmail;
